import { ref } from '@vue/composition-api';

const userMenu = ref(false);
const changePasswordMenu = ref(false);
const settingsMenu = ref(false);
const mustChangePassword = ref(false);

export { userMenu, changePasswordMenu, settingsMenu, mustChangePassword };
